module.exports = __webpack_public_path__ + "img/1092904387.718f0a93.jpg";